import { BaseFileUploader } from '@/abstracts/base-file-uploader';
import { FileUploaderV1 } from '@/providers/file-uploaders/file-uploader.v1';
import { FileUploaderV2 } from '@/providers/file-uploaders/file-uploader.v2';
import type { FileVersion } from '@/services/types/file.types';

export class FileUploaderFactory {
  private constructor() {}

  public static create(version: FileVersion): BaseFileUploader {
    switch (version) {
      case 'v2':
        return new FileUploaderV2(version);
      default:
        return new FileUploaderV1(version);
    }
  }
}
